import { useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link'; 
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';


import classnames from 'classnames';

import './Memberships.scss';

const membershipData = [
    {
        type: "couples",
        displayType: "Couples",
        overview: <SwingMembershipOverview />,
        notes: { 
            annual: "Membership loyalty discount - save $25 when you renew your membership before it expires",
            nightly: "Receive a $10 discount for making an event reservation 48 hours in advance."
        },
        levels: [ 
            {
                name: 'One Night Trial',
                annualFee: "$0",
                nightlyFee: "$90",
                html: `
                    <p>We are now offering a special 1-day couples pass for $90. You still need to complete an online Basic membership application and sign a privacy agreement, but this will allow you to attend an event to see if the club is right for you without paying for the membership/application fee - This is also a great option for couples traveling to and visiting the area. To take advantage of this offer, you MUST arrive to the event before 9 pm. If arriving after 9 pm, you will be required to purchase an annual membership in addition to the cost of the event.</p>
                    <p>If you decide to return (we know you will!), at your next event you will then pay for your membership/application fee and the normal event pricing.</p>
                `,
            },
            {
                name: 'Basic',
                annualFee: "$45",
                nightlyFee: "$90",
                html: `<p>For couples who can only come a few times a year, or who need to spread the cost out over a longer period, this is the best option for you. Discounts are provided on event fees for advanced reservations.</p>`,
            },
            {
                name: 'Premium',
                annualFee: "$275",
                nightlyFee: "$60",
                html: `
                    <p>If you attend frequently (at least every other month), this membership will save you money by offering reduced event fees. Discounts are provided on event fees for advanced reservations.</p>
                    <p>Premium members have the option to upgrade for the use of the VIP space during any event at an additional cost of $50. Upgrade requests must be made at the time of check and a signed VIP upgrade agreement is required. Additional rules and conditions apply, please inquire during the check -in process.</p>
                `,
            },
        ],
    },
    {
        type: "single-women",
        displayType: "Single Women",
        overview: <SwingMembershipOverview />,
        notes: {
            annual: "Membership loyalty discount - save $25 when you renew your membership before it expires",
            nightly: "Arrive before 9:00p and we waive the event fee (no cover)."
        },
        levels: [
            {
                name: 'Premium',
                annualFee: "$65",
                nightlyFee: "$5",
                html: `<p>Our Premium level membership includes benefits such as discounts to select classes. Admission is <b>free</b> for those who arrive by 9:00p.</p>`,
            },
        ],
    },
    {
        type: "single-men",
        displayType: "Single Men",
        overview: <SwingMembershipOverview />,
        notes: {
            annual: "Membership loyalty discount - save $25 when you renew your membership before it expires",
            nightly: "When attending with a female guest, we treat you as a couple for reservations and event fee pricing."
        },
        levels: [
            {
                name: 'Intro',
                annualFee: "$100",
                nightlyFee: "$100",
                html: `<p>This is a 3-month version of our Basic membership. This membership tier is the only way to join the Club for new single men or returning singles that we have not seen in a while. An Intro membership allows you an opportunity to see if the Club matches your expectations, and gives us a chance to see how you fit with the rest of our members before committing to a full year of membership.</p>`,
            },
            {
                name: 'Basic',
                annualFee: "$250",
                nightlyFee: "$100",
                html: `<p>With a Basic membership, we ensure you may attend our special interest parties called &ldquo;Insatiable&rdquo; that do not have limits on the number of single guys. You may make reservations for any event, and provided we have space, we will confirm your reservation the day of the event. When attending with a female guest, your event fees are the same as a Basic couple.</p>`,
            },
            {
                name: 'Premium',
                annualFee: "$575",
                nightlyFee: "$100",
                html: `<p>Premium membership is only available to existing members. All Basic guys are automatically put on our waiting list for Premium memberships. When you reach the top of the list we will contact you to see if you would like to upgrade or move to the bottom of the list for future consideration. As a Premium guy you jump to the front of the line when making reservations for events. Premium reservations are confirmed in the order they are received as slots becomes available for a given event. When attending with a female guest, your event fees are the same as a Premium couple.</p>`,
            },
        ],
    },
    {
        type: "fetish",
        displayType: "Fetish",
        overview: <FetishMembershipOverview />,
        notes: {
            annual: "Membership loyalty discount - save $25 when you renew your membership before it expires. Discounts to Swinger Members with a Premium or VIP Membership (and are vetted Fetish Members).",
        },
        levels: [
            {
                name: 'Single',
                annualFee: "$45",
                nightlyFee: "$40",
                html: `<p>This membership is only available for vetted singles as described above.</p>`,
            },
            {
                name: 'Couple',
                annualFee: "$65",
                nightlyFee: "$80",
                html: `<p>This membership is only available for vetted couples as described above.</p>`,
            },
        ],
    },
];


function SwingMembershipOverview(props) {
    return(
        <Container className="info-panel">
            <p>
                We are always looking for open - minded folks to join our sexually adventurous community and have structured our membership levels to accommodate everyone.
                We take pride in maintaining a discrete, clean, comfortable, and inviting environment filled with fun and adventurous adults.
                Choice is a 21 + club, but the majority of our members are couples in their 30s to 50s.
                While we do allow single women and single men, we gender balance our parties unless specifically advertised.
            </p>

            <p>
                Please note that as a private membership club, you must join our membership before you can attend events at our location.
                We give all applicants a quick phone call to make sure we answer any questions you have about the club <i>before</i> your first night.
                To ensure we have enough time to get back to you, please submit your application at least one week before the event you wish to attend.
            </p>

            <p>
                <b>NOTE</b>: All application follow-up conversations must be conducted over the phone and cannot be completed at the club.
            </p>
        </Container>
    );
}

function FetishMembershipOverview(props) {
    return (
        <Container className="info-panel">
            
            <p>
                We are pleased to introduce memberships for members of the Fetish community.
                At this time, we are only accepting memberships from individuals are known in the community and who have been brought to several
                Choice events by current members.
                In order to be considered for membership, you must be sponsored by a current member and attend a minimum of three Fetish Events.
            </p>

            <p>
                Looking to get an introduction to fellow kinksters?
                Start by learning more about the community through <a href="https://nelaonline.org">NELA</a> and <a href="http://www.ne-ds.org/">NEDS</a>.
                Get involved in social networking through <a href="https://www.fetlife.com">FetLife</a> to learn about local munches in your area.
                By attending munches or classes such as <a href="https://fetlife.com/groups/42462">Worcester Rope Group</a>, <a href="https://fetlife.com/groups/57717">SeaCoast Area Group (SCAR)</a>, or <a href="https://fetlife.com/groups/46627">Rhode Island Rope Sluts (RIRS)</a> to meet folks who can extend an invivtation to attend as their guest.
                For those in the 35 or younger category, we highly recommend checking out the <a href="https://www.fetlife.com">Rhode Island's Kinky Youth (RISKY)</a> munch.
            </p>

            <p>
                Please note that as a private membership club, you must <a href="join.php">join our membership</a> before you can attend events at our location.
                To ensure we have enough time to get back to you, please submit your application well before the event you wish to attend.
            </p>
        </Container>
    );
}


function MembershipTypeSelector({
    type,
    setType,
    membershipData,
}) {

    const availableTypes = membershipData.map((x) => 
        <div 
            key={x.type}
            className={classnames("type-item", { "active": x.type===type})} 
            onClick={() => setType(x.type)}
        >
            {x.displayType}
        </div>
    );

    return(
        <div className="membership-selector">
            {/* <div className='type-item-header'>Memberships for</div> */}
            {availableTypes}
        </div>
    )
}

function MembershipLevel({
    level,
    notes,
}) {
    return(
        <Col>
            <Card className="level-card">
                <Card.Header>{level.name}</Card.Header>
                <Card.Body>
                    <Card.Text>
                        <span dangerouslySetInnerHTML={{ __html: level.html }} />
                    </Card.Text>
                    <table className="fee-table">
                        <tbody>
                            <tr>
                                <td>Annual Dues<sup> { notes.annual && <HashLink to="#footnotes">[a]</HashLink>}</sup></td>
                                <td>{level.annualFee}</td>
                            </tr>
                            <tr>
                                <td>Typical Event Fee<sup> { notes.nightly && <HashLink to="#footnotes">[b]</HashLink>}</sup></td>
                                <td>{level.nightlyFee}</td>
                            </tr>
                        </tbody>
                    </table>
                    <Link to="/join">
                        <Button variant="outline-light"><b>Join now</b></Button>
                    </Link>
                </Card.Body>
            </Card>
        </Col>
    )
}

function LevelNotes ({
    notes
}) {
    return(
        <a href="#footnotes" id="footnotes">        
            <div className="footnotes">
                { notes.annual && <p>[a] {notes.annual} </p>}
                { notes.nightly && <p>[b] {notes.nightly} </p>}
            </div>
        </a>
    )
}

export function Memberships(props) {
    const { defaultType } = useParams();
    const [type, setType] = useState(defaultType || "couples");

    const details = membershipData.find((x) => x.type === type);

    const levelCards = details.levels.map((x) => <MembershipLevel key={`${details.type}-${x.name}`} level={x} notes={details.notes} />)

    const noteCard = <LevelNotes notes={details.notes} />

    return (
        <Container className="memberships p-0" fluid>
            <h1>Become a Member</h1>

            <MembershipTypeSelector type={type} setType={setType} membershipData={membershipData} />

            {details.overview}
            
            <Row xs={1} lg={2} xl={3} className="g-4">
                {levelCards}
            </Row>
            
            <Row xs={1} className="g-4">
                {noteCard}
            </Row>
        </Container>
    );

}
